// src/components/Seguridad/Components/Catalogos/EmpleadosAreaNegocio/EmpleadosAreaNegocioPage.jsx
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaUserCircle, FaHome } from 'react-icons/fa';
import EmpleadosAreaNegocioCatalog from './EmpleadosAreaNegocioCatalog';

export default function EmpleadosAreaNegocioPage() {
  const isSmall = isMobile || isTablet;

  return (
    <div className="panel-sigma-layout">
      <aside
        className={`panel-sigma-sidebar ${
          isSmall ? 'panel-sigma-sidebar-responsive' : ''
        }`}
      >
        <div className="panel-sigma-user">
          {!isSmall && (
            <>
              <FaUserCircle size={48} />
              <div>
                <div className="panel-sigma-user-name">Empleado</div>
                <div className="panel-sigma-user-role">Área de Negocio</div>
              </div>
            </>
          )}
        </div>

        {isSmall && (
          <div className="panel-sigma-user-mini">
            <FaUserCircle size={48} />
          </div>
        )}
        <nav className="panel-sigma-nav">
          <button title="Inicio">
            <FaHome />
          </button>
        </nav>
      </aside>

      <EmpleadosAreaNegocioCatalog />
    </div>
  );
}
